// Generated by `npm run i18n:types` from src/i18l/de. Do not edit by hand.

import type { I18n } from '../types'
import sharedApp from './shared/app.json'
import sharedCommon from './shared/common.json'
import sharedComponents from './shared/components.json'
import sharedErrors from './shared/errors.json'
import sharedNav from './shared/nav.json'
import sharedNotifications from './shared/notifications.json'
import applications from './applications.json'
import assets from './assets.json'
import attachments from './attachments.json'
import calendarNotes from './calendarNotes.json'
import changeRequests from './changeRequests.json'
import contracts from './contracts.json'
import conversations from './conversations.json'
import dashboard from './dashboard.json'
import enrolments from './enrolments.json'
import inbox from './inbox.json'
import jobs from './jobs.json'
import news from './news.json'
import notPresent from './notPresent.json'
import profiles from './profiles.json'
import reports from './reports.json'
import settings from './settings.json'
import timeClock from './timeClock.json'
import timestamps from './timestamps.json'
import workSafety from './workSafety.json'
import workTemplate from './workTemplate.json'
import workTimes from './workTimes.json'

export const de: I18n = {
    shared: {
        app: sharedApp,
        common: sharedCommon,
        components: sharedComponents,
        errors: sharedErrors,
        nav: sharedNav,
        notifications: sharedNotifications,
    },
    applications,
    assets,
    attachments,
    calendarNotes,
    changeRequests,
    contracts,
    conversations,
    dashboard,
    enrolments,
    inbox,
    jobs,
    news,
    notPresent,
    profiles,
    reports,
    settings,
    timeClock,
    timestamps,
    workSafety,
    workTemplate,
    workTimes,
}

export default de
